import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Modal, Form, Row, Col, Table, Dropdown } from 'react-bootstrap';
import { MdAirplaneTicket, MdCardTravel, MdLandslide, MdMoneyOff, MdOutlineDiscount, MdOutlineSupport, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCodePromosAll, fetchCodePromosOfIdUserAll, createPromoCode, fetchCodePromoByUpdateId, fetchCodePromoById } from '../../../actions/request/CodePromoRequest';
import { getAndCheckLocalStorage } from '../../../utils/storage/localvalueFuction';
import { localStorageKeys } from '../../../utils/storage/localvalue';
import { toast } from 'react-toastify';
import { RiFileDamageFill } from 'react-icons/ri';

import { FaTools } from 'react-icons/fa';
import { VehicleBrandCreate, VehicleBrandUpdateById, fetchVehicleBrandsAll } from '../../../actions/request/VehicleBrandRequest';

const BrandsPage = () => {


    const dispatch = useDispatch();
    const vehiclebrands = useSelector((state) => state.vehiclebrands.vehiclebrands);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [promoCodeData, setPromoCodeData] = useState({
        name: '',
        description: '',
    });
    const [selectedPromoCode, setSelectedPromoCode] = useState(null);
    const [showCode, setShowCode] = useState({});
    const itemsPerPage = 50;

    useEffect(() => {
        dispatch(fetchVehicleBrandsAll());
    }, [dispatch]);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setPromoCodeData({ name: "", description: "" });
        setSelectedPromoCode(null);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPromoCodeData((prevState) => ({ ...prevState, [name]: value }));
    };

    const handleCreateOrUpdatePromoCode = () => {
        if (selectedPromoCode) {
            if (!promoCodeData.name && !promoCodeData.description) {
                toast.error("Veillez renseignez tous les champs s'il vous plait . ", { position: "bottom-right" })
                return;
            }
            dispatch(VehicleBrandUpdateById(selectedPromoCode?._id, promoCodeData));
        }
        else {
            // const userAdd = getAndCheckLocalStorage(localStorageKeys.userId);
            if (!promoCodeData.name && !promoCodeData.description) {
                toast.error("Veillez renseignez tous les champs s'il vous plait . ", { position: "bottom-right" })
                return;
            }
            dispatch(VehicleBrandCreate({ ...promoCodeData }));
        }
        handleCloseModal();
    };

    const handleEditPromoCode = (promoCode) => {
        setSelectedPromoCode(promoCode);
        setPromoCodeData({
            name: promoCode.name,
            description: promoCode.description,
        });
        handleShowModal();
    };

    const handleValidatePromoCode = (code) => {
        dispatch(fetchCodePromoById(code));
    };

    const handleToggleShowCode = (promoId) => {
        setShowCode((prevState) => ({ ...prevState, [promoId]: !prevState[promoId] }));
    };

    const paginatedPromoCodes = vehiclebrands.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) || [];



    return (
        <div>
            <Card>
                <Card.Header>
                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <h3 className="mb-4"><MdCardTravel /> Marques de véhicules</h3>
                        </div>
                        <div>
                            <Button title="Ajouter une nouvelle marque de véhicule"
                                variant="primary"
                                size='sm'
                                className="ml-2"
                                onClick={handleShowModal}
                            >
                                + Ajouter
                            </Button>
                        </div>
                    </div>
                </Card.Header>

                <Card.Body style={{ minHeight: "400px" }} >
                    {paginatedPromoCodes && paginatedPromoCodes.length > 0 ? (
                        <div className="align-content-between">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>Titre</th>
                                        <th>Description</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedPromoCodes.map((promo) => (
                                        <tr key={promo._id}>
                                            <td>
                                                {promo?.name || ""}
                                            </td>
                                            <td>{promo?.description || ""}</td>
                                            <td>
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="primary" size="sm">
                                                        Actions
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => handleEditPromoCode(promo)}>Modifier</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <div className="d-flex justify-content-start mt-4">
                                <Button
                                    variant="primary"
                                    size="sm" className="p-2"
                                    disabled={currentPage === 1}
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                    Précédent
                                </Button>
                                
                                <Button
                                    variant="primary"
                                    size="sm" className="p-2"
                                    disabled={currentPage * itemsPerPage >= vehiclebrands.length}
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                >
                                    Suivant
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <Alert variant="light" style={{ display: "flex", justifyContent: "center" }}>Aucune marque </Alert>
                    )}
                </Card.Body>
            </Card>

            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedPromoCode ? "Modifier marque de véhicule" : "Nouvelle marque de véhicule"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="discountPercentage">
                            <Form.Label>Titre<span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                style={{ height: "40px" }}
                                type="text"
                                name="name"
                                placeholder=''
                                value={promoCodeData.name}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                        <Form.Group controlId="expiryDate">
                            <Form.Label>Description <span className="text-danger">*</span></Form.Label>
                            <Form.Control
                                as={"textarea"}
                                style={{ height: "50px" }}
                                type="text"
                                name="description"
                                value={promoCodeData.description}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" size="sm" onClick={handleCloseModal}>Annuler</Button>
                    <Button variant="primary" size="sm" onClick={handleCreateOrUpdatePromoCode}>{selectedPromoCode ? 'Mettre à Jour' : 'Créer'}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default BrandsPage;